import { menuCheck } from "../api";
import { toast } from "../hooks/use-toast";
import React, { useEffect } from "react";
import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { QrCode, LayoutDashboard, Share2, UtensilsCrossed, Shield, LogOut, Menu as MenuIcon, Tag, Users, Megaphone, BarChart3, Globe } from "lucide-react";
import { Button } from "../components/ui/button";
import { useAuth } from "../context/AuthContext";
import { useState } from "react";

export default function AppShell() {
  const { user, company, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const isAdmin = user?.role === "superadmin";
  useEffect(() => {
    const t = localStorage.getItem("qora_mc_claim");
    if (t && user && !isAdmin) { menuCheck.claim(t).then(() => { localStorage.removeItem("qora_mc_claim"); toast({ title: "Menu Check salvato", description: "Analisi e richieste sono state collegate al tuo account." }); }).catch(() => {}); }
  }, [user, isAdmin]);

  const nav = isAdmin
    ? [{ to: "/app/admin", label: "Amministrazione", icon: Shield, end: true }, { to: "/app/admin/seo", label: "SEO & AI Visibility", icon: Globe }, { to: "/app/admin/minisite", label: "Qora MiniSite", icon: Share2 }, { to: "/app/admin/menu-check", label: "Qora Menu Check", icon: Shield }]
    : [
        { to: "/app", label: "La tua attività", icon: LayoutDashboard, end: true },
        { to: "/app/qr", label: "Qora QR", icon: QrCode },
        { to: "/app/statistiche", label: "Statistiche", icon: BarChart3 },
        { to: "/app/pagine", label: "Qora Link", icon: Share2 },
        { to: "/app/print-kit", label: "Print Kit", icon: QrCode },
        { to: "/app/menu", label: "Qora Menu", icon: UtensilsCrossed },
        { to: "/app/promozioni", label: "Promozioni", icon: Megaphone },
        { to: "/app/servizi", label: "Servizi", icon: Tag },
        { to: "/app/team", label: "Team", icon: Users },
      ];

  const SideContent = () => (
    <>
      <Link to="/app" className="flex items-center gap-2 px-2 h-16">
        <img src="/qora-logo.png" alt="Qora" className="h-8 w-auto" />
      </Link>
      <nav className="flex-1 px-2 space-y-1 mt-2">
        {nav.map((n) => {
          const Icon = n.icon;
          return (
            <NavLink key={n.to} to={n.to} end={n.end} onClick={() => setOpen(false)}
              className={({ isActive }) => `flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-colors ${isActive ? "btn-grad text-white shadow-sm" : "text-foreground/70 hover:bg-muted"}`}>
              <Icon className="h-[18px] w-[18px]" /> {n.label}
            </NavLink>
          );
        })}
      </nav>
      <div className="p-3 border-t border-border">
        <div className="px-2 mb-2">
          <p className="text-sm font-semibold truncate">{isAdmin ? "Qora Admin" : company?.name}</p>
          <p className="text-xs text-muted-foreground truncate">{user?.email}</p>
        </div>
        <Button variant="ghost" className="w-full justify-start gap-2 text-muted-foreground" onClick={() => { logout(); navigate("/login"); }}>
          <LogOut className="h-4 w-4" /> Esci
        </Button>
      </div>
    </>
  );

  return (
    <div className="min-h-screen bg-muted/30 flex">
      <aside className="hidden md:flex w-64 flex-col border-r border-border bg-white fixed inset-y-0">
        <SideContent />
      </aside>

      {open && (
        <div className="md:hidden fixed inset-0 z-40">
          <div className="absolute inset-0 bg-black/40" onClick={() => setOpen(false)} />
          <aside className="absolute inset-y-0 left-0 w-64 flex flex-col bg-white"><SideContent /></aside>
        </div>
      )}

      <div className="flex-1 min-w-0 md:ml-64">
        <header className="md:hidden sticky top-0 z-30 h-14 glass border-b border-border flex items-center justify-between px-4">
          <button onClick={() => setOpen(true)}><MenuIcon className="h-6 w-6" /></button>
          <span className="font-display font-extrabold">Qora</span>
          <span className="w-6" />
        </header>
        <div className="p-5 md:p-8 max-w-6xl mx-auto"><Outlet /></div>
      </div>
    </div>
  );
}
